import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

export type MessageProps = React.HTMLAttributes<HTMLDivElement> & {
  header?: React.ReactNode;
  content?: React.ReactNode;
  error?: boolean;
  fluid?: boolean;
  info?: boolean;
  success?: boolean;
  warning?: boolean;
};

const BaseMessage = styled.div`
  p {
    margin: 4px 0 8px;
  }

  button,
  a {
    text-decoration: underline;
    font-weight: 600;
  }

  b {
    font-weight: 600;
  }

  > div:not(.header):not(:only-child) {
    margin-top: 4px;
  }

  ul {
    text-align: left;
    padding: 0;
    list-style-position: inside;
    margin: 0.5em 0 0;

    li {
      position: relative;
      margin: 0 0 0.3em 1em;
      padding: 0;
    }
  }

  .header {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 4px;
  }

  border: 1px solid ${props => props.theme.colors.darkgrey};
  background-color: #f8f8f8;

  &.info {
    border: 1px solid ${props => props.theme.colors.blue};
    background-color: #f7fafb;
    color: ${props => props.theme.colors.blue};
  }

  &.error {
    background: #fff4f4;
    color: ${props => props.theme.colors.red};
    border: 1px solid ${props => props.theme.colors.red};

    a {
      font-weight: 600;
      color: ${props => props.theme.colors.red};
    }
  }

  &.success {
    background: #e6faf1;
    color: ${props => props.theme.colors.green};
    border: 1px solid ${props => props.theme.colors.green};

    a {
      font-weight: 600;
      color: ${props => props.theme.colors.green};
    }
  }

  &.warning {
    background: #fef9ee;
    color: #e1840e;
    border: 1px solid #e1840e;
  }

  // If it's the last thing in the area, but not the only one.
  //&:last-child:not(:only-child) {
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Message = React.forwardRef<any, MessageProps>(
  (
    {
      children,
      className,
      error,
      fluid,
      info,
      warning,
      content,
      success,
      header,
      ...props
    },
    ref,
  ) => (
    <BaseMessage
      {...props}
      className={classNames(
        'relative rounded text-left my-4 px-4 py-2',
        {
          error,
          fluid,
          info,
          warning,
          success,
        },
        className,
      )}
      ref={ref}
    >
      {header && <div className="header">{header}</div>}
      {typeof content === 'string' ? <div>{content}</div> : content}
      {children}
    </BaseMessage>
  ),
);
